import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { ReportIssueError, ReportIssueRequest, ReportIssueResponse } from '@/api/model';

const request = {
  postReportIssue: async ({ payload }: ReportIssueRequest) => {
    const { data } = await fetchClient.FCT.post<ReportIssueResponse>(
      ENDPOINTS.FCT.APPS.REPORT_ISSUE,
      { body: payload },
    );

    return data;
  },
};

const mutation = {
  usePostReportIssue: () =>
    useMutation<ReportIssueResponse, ReportIssueError, ReportIssueRequest>({
      mutationFn: request.postReportIssue,
    }),
};

export const reportIssue = {
  mutation,
  request,
};
